"use strict";
exports.setQuarter = setQuarter;
var _index = require("./setMonth.js");
var _index2 = require("./toDate.js");
function setQuarter(date, quarter) {
  const _date = (0, _index2.toDate)(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return (0, _index.setMonth)(_date, _date.getMonth() + diff * 3);
}
